<template>
  <v-container fluid>
    <v-card
        class="mx-auto"
        max-width="600"
        outlined
      >
      <v-alert
        v-if="isPrivate"
        border="bottom"
        colored-border
        type="warning"
        elevation="2"
        light
      >
        {{ $t('settings.privateMode') }}
      </v-alert>
      <!-- registrace -->
      <v-row v-if="!iid" justify="center" fluid class="px-4">
          <v-alert
            v-if="connect"
            class="mt-4"
            type="info">
             <b>{{ connect.nick }}</b> {{ $t('settings.connect') }}
          </v-alert>
          <v-alert
            border="bottom"
            colored-border
            type="warning"
            elevation="2"
            light
          >
            <p>
              {{ $t('settings.disclaimer') }} <a class="caption" href="https://www.meeconn.cz">https://www.meeconn.cz</a>
            </p>
            <p>
              {{ $t('settings.beforestart') }}
            </p>
          </v-alert>
          <v-btn class="my-2" color="red" @click="generate">{{ $t('settings.generate') }}</v-btn>
          <v-progress-linear
            v-if="progress"
            indeterminate
            color="red darken-2"
            class="mt-4"
          ></v-progress-linear>
          <v-alert class="mt-4" type="info">
            <p>
              {{ $t('settings.privacy') }}
            </p>
          </v-alert>
          <McImportExport :showOnlyImport="true" importButtonText="settings.importButton"></McImportExport>
      </v-row>
      <!-- formulář -->
      <v-form v-else v-model="valid">
        <h2 class="ma-2">{{ $t('settings.title') }}</h2>
        <v-container>
          <v-row justify="center" align="center">
            <v-col cols="10" class="ma-0 pa-0">
              <v-text-field
                v-model="nick"
                :counter="100"
                :rules="nickRules"
                :label="$t('app.att.nick')"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="ma-0 pa-0">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">mdi-information-outline</v-icon>
                </template>
                <span>{{ $t('settings.nick') }}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="10" class="ma-0 pa-0">
              <v-checkbox
                v-model="allowSearchNick"
                :label="$t('settings.allowSearchNick')"
              ></v-checkbox>
            </v-col>
            <v-col cols="1" class="ma-0 pa-0">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">mdi-information-outline</v-icon>
                </template>
                <span>{{ $t('settings.allowSearchNickTooltip') }}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="10" class="ma-0 pa-0">
              <v-text-field
                v-model="tribe"
                :counter="20"
                :rules="tribeRules"
                :label="$t('app.att.tribe')"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="ma-0 pa-0">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">mdi-information-outline</v-icon>
                </template>
                <span>{{ $t('settings.tribe') }}</span>
              </v-tooltip>
            </v-col>
            <!--
            <v-col cols="10" class="ma-0 pa-0">
              <v-text-field
                v-model="zip"
                :rules="zipRules"
                :label="$t('app.att.zip')"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="ma-0 pa-0">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">mdi-information-outline</v-icon>
                </template>
                <span>{{ $t('settings.zip') }}</span>
              </v-tooltip>
            </v-col>
            -->
            <v-col cols="10" class="ma-0 pa-0">
              <v-row class="d-flex justify-center">
                <h5 class="justify-center">{{ $t('settings.healthStatusLabel') }}</h5>
              </v-row>
              <v-row class="d-flex justify-center my-2">
                <v-btn-toggle
                  v-model="health"
                  mandatory
                >
                  <v-btn rounded :color="(health === 0) ? 'green' : 'grey'"><v-icon>mdi-emoticon-happy-outline</v-icon></v-btn>
                  <v-btn rounded :color="(health === 1) ? 'orange' : 'grey'"><v-icon>mdi-emoticon-neutral-outline</v-icon></v-btn>
                  <v-btn rounded :color="(health === 2) ? 'red' : 'grey'"><v-icon>mdi-emoticon-sad-outline</v-icon></v-btn>
                </v-btn-toggle>
              </v-row>
              <!--
              <v-select
                 :value="health"
                 :items="healthStatus"
                 outlined
                 @input="updateHealth"
               ></v-select>
              -->
            </v-col>
            <v-col cols="1" class="ma-0 pa-0">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">mdi-information-outline</v-icon>
                </template>
                <span>{{ $t('settings.healthStatusInfo') }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-container>
        <v-row class="d-flex justify-center">
            <v-btn :disabled="!valid" class="mr-4 mb-2" color="primary" @click="save">{{ $t('app.btn.save') }}</v-btn>
        </v-row>
        <McImportExport :showOnlyImport="false" importButtonText="app.btn.import"></McImportExport>
        <McErase></McErase>
      </v-form>
    </v-card>
    <!-- confirmation dialog -->
    <v-dialog v-model="confirmationDialogShow" persistent max-width="500" light>
      <v-card max-width="600">
        <v-card-title class="subtitle-1">
            {{ $t('settings.generated1') }}
        </v-card-title>
        <v-card-subtitle class="subtitle-2 py-2">{{ $t('settings.generatedSteps')}}</v-card-subtitle>
        <v-card-text class="">
          <v-row>
            <v-col cols="1">
              <v-icon small color="grey">mdi-numeric-1-circle-outline</v-icon>
            </v-col>
            <v-col cols="11">
              {{ $t('settings.generated2') }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1">
              <v-icon small color="grey">mdi-numeric-2-circle-outline</v-icon>
            </v-col>
            <v-col cols="11">
              {{ $t('settings.generated3') }}
            </v-col>
          </v-row>
          <v-alert
            border="bottom"
            colored-border
            type="warning"
            elevation="2"
            light
          >
            <p>
              {{ $t('settings.security') }}
            </p>
          </v-alert>
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
            <!--
            <v-btn color="primary" small to="/help/0">{{ $t('app.help') }}</v-btn>
            -->
            <v-btn color="primary" small @click="confirmationDialogClose()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { mapState, mapGetters } from 'vuex'
import McImportExport from '@/components/McImportExport.vue'
import McErase from '@/components/McErase.vue'
import privateModeTester from '@/private/is-private-mode.js'

export default {
  name: 'Settings',
  components: {
    McImportExport,
    McErase
  },
  data: () => ({
    //TODO
    isPrivate: false,
    confirmationDialogShow: false,
    valid: false,
    progress: false,
    nickRules: [
      v => v.length <= 100 || 'Maximálně 100 znaků',
    ],
    tribeRules: [
      v => v.length <= 20 || 'Maximálně 20 znaků',
    ],
    zipRules: [
      v => /\d{3} ?\d{2}/.test(v) || 'Špatný formát PSČ',
    ],
    connect: null
  }),
  computed: {
    nick: {
      get () {
        return this.$store.state.nick
      },
      set (value) {
        this.$store.dispatch('updateNick', value)
      }
    },
    allowSearchNick: {
      get () {
        return this.$store.state.allowSearchNick
      },
      set (value) {
        this.$store.dispatch('updateAllowSearchNick', value)
      }
    },
    zip: {
      get () {
        return this.$store.state.data.zip
      },
      set (value) {
        this.$store.dispatch('updateZip', value)
      }
    },
    tribe: {
      get () {
        return this.$store.state.data.tribe
      },
      set (value) {
        if (this.valid) {
          this.$store.commit('updateTribe', value)
        }
      }
    },
    health: {
      get () {
        return this.$store.state.data.health
      },
      set (value) {
        if (this.valid) {
          this.$store.commit('updateHealth', value)
        }
      }
    },
    ...mapState(['pid', 'iid']),
    ...mapGetters(['healthStatus'])
  },
  mounted() {
    var self = this
    privateModeTester.isPrivateMode().then(function (isPrivate) {
        self.isPrivate = isPrivate
    });
    if(this.$route.params.link) {
      var parts = this.$route.params.link.split(';')
      if (parts.length > 2) {
        this.connect = {cor: parts[0], pid: parts[1], nick: parts[2], link: this.$route.params.link}
      } else {
        this.connect = {cor: parts[0], pid: parts[0], nick: 'Uživatel', link: this.$route.params.link}
      }
    }
  },
  methods: {
    confirmationDialogClose() {
        this.confirmationDialogShow = false
        this.$store.commit('first', true)
    },
    async generate() {
      try {
        this.progress = true
        await this.$store.dispatch('generate')
        this.confirmationDialogShow = true
        this.progress = false
      } catch (err) {
          this.progress = false
          this.$emit('error', err)
      }
    },
    async save() {
      this.$emit('toSynchronize')
      var path = "/"
      if (this.connect) {
        path = "/c/" + this.connect.link
      } else {
        if (this.$store.state.first) {
          path = "/requests"
        }
      }
      await this.$router.push({path: path})
    },
    updateHealth(value) {
      this.$store.commit('updateHealth', value)
    }
  }
}
</script>
